import { useMutation } from "@tanstack/react-query";
import { fetchClient } from "@/lib/api-client";

/** Publish a draft: validates required fields, snapshots weight, opens voting. */
export const usePublishStatementDraft = () =>
  useMutation({
    mutationFn: async ({ params }: { params: { path: { id: string } } }) => {
      const { data, error } = await (
        fetchClient as unknown as {
          POST: (
            path: "/statements/drafts/{id}/publish",
            init: { params: { path: { id: string } } },
          ) => Promise<{ data?: unknown; error?: unknown }>;
        }
      ).POST("/statements/drafts/{id}/publish", { params });
      if (error) throw error;
      return data;
    },
  });
